import React from 'react';

interface GuestPreviewSectionProps {
  title: string;
  children: React.ReactNode;
}

export const GuestPreviewSection: React.FC<GuestPreviewSectionProps> = ({
  title,
  children,
}) => {
  return (
    <section className="space-y-4">
      <div className="border-b border-gray-100 pb-3">
        <h3 className="text-sm font-bold uppercase tracking-wide text-gray-600">
          {title}
        </h3>
      </div>
      {children}
    </section>
  );
};
